__webpack_require__.p = "https://dnd-tools.hpmason.com/";